import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import "./AboutUs.css";
import ImageSlider from "../../components/ImageSlider/ImageSlider";
import FestiveLoan from "../../assets/Images/Home/FestiveLoan.jpg";
import EducationLoan from "../../assets/Images/Home/EducationLoan.jpg";
import ShoppingLoan from "../../assets/Images/Home/ShoppingLoan.jpg";
import EmergencyLoan from "../../assets/Images/Home/EmergencyLoan.jpg";
import LifestyleLoans from "../../assets/Images/Home/LifestyleLoans.jpg";
import TeamMemberCard from "../../components/TeamMember/TeamMemberCard";
import TextImageSection from "../Home/component/TextImageSection";
import aboutUs_loan from "../../assets/Images/Home/aboutUs_loan.jpg"
import instaLoanCreditTool from "../../assets/Images/Home/instaLoanCreditTool.jpg";
import { JobCard } from "../../components/JobCard/JobCard";

export const AboutUs = () => {
  const images = [
    FestiveLoan,
    EducationLoan,
    ShoppingLoan,
    EmergencyLoan,
    LifestyleLoans,
  ];
  const teamMembers = [
    {
      name: "Vikram Das",
      title: "Founder & CEO",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.",
    },
    {
      name: "Rahul Mehta",
      title: "CTO",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.",
    },
  ];
  const jobs = [
    {
      title: "Project Manager",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et",
      tags: ["Full time", "On site"],
      buttonText: "Apply now",
    },
    {
      title: "Project Manager",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et",
      tags: ["Full time", "On site"],
      buttonText: "Apply now",
    },
  ];
  return (
    <>
      <Navbar />
      <div className="home-section flex justify-center items-center">
      <TextImageSection
            view={"heading-then-image"}
            image={aboutUs_loan}
            heading={"Need Assistance? We’re Here to Help!"}
            custumeClass="center-section leading-partner image-hr-text insta-loan credit-tool-instaloan loan-product-page blogs-page"
          ></TextImageSection>
        <div className="about-us-section">
          <h1 className="about-us-chip">About us</h1>
          <h1 className="about-us-light-heading">Life moves fast,</h1>
          <h1 className="about-us-dark-heading">so should you</h1>
          <p className="about-us-description">
            At FastFin, we recognize the challenges of unexpected expenses and
            aim to break through traditional banking barriers to provide timely
            assistance. We are a digital platform that facilitates easy access
            to funds without any.
          </p>
        </div>
      </div>
      <ImageSlider images={images} />
      <div className="about-us-story-section">
        <div className="about-us-detail">
          <h1>Our Story</h1>
        </div>
        <div className="about-story-description">
          <p>
            At FastFin, we recognize the challenges of unexpected expenses and
            aim to break through traditional banking barriers to provide timely
            assistance. We are a digital platform that facilitates easy access
            to funds without any paperwork or approvals.
          </p>
          <p>
            At FastFin, we recognize the challenges of unexpected expenses and
            aim to break through traditional banking barriers to provide timely
            assistance. We are a digital platform that facilitates easy access
            to funds without any paperwork or approvals.
          </p>
          <p>
            At FastFin, we recognize the challenges of unexpected expenses and
            aim to break through traditional banking barriers to provide{" "}
          </p>
        </div>
      </div>

      <div class="color-section home-section flex justify-center items-center about-us-team-section">
        <h1>Our Leadership Team</h1>
        <div className="about-us-team">
          {teamMembers.map((member, index) => (
            <TeamMemberCard
              key={index}
              name={member.name}
              title={member.title}
              description={member.description}
            />
          ))}
        </div>
      </div>
      <div className="home-section flex justify-center items-center">
        <div class="info-section">
          <div class="content-info">
            <div className="join-our-team">
              <h2>Join our team</h2>
              <div className="job-list">
                {jobs.map((job, index) => (
                  <JobCard
                    key={index}
                    title={job.title}
                    description={job.description}
                    tags={job.tags}
                    buttonText={job.buttonText}
                  />
                ))}
              </div>
            </div>
          </div>
          <div class="image-info">
            <img src="/static/media/Group-425.64e9c0ad2a90a986edec.jpg" />
          </div>
        </div>
      </div>

      <div className="credit-tool-section">
        <TextImageSection
          view={"heading-then-image"}
          image={instaLoanCreditTool}
          heading={"Instant loan to move up in life"}
          // headingSecond={"Approved in 10 Minutes!"}
          button="Apply Now"
          custumeClass="center-section leading-partner image-hr-text insta-loan credit-tool-instaloan"
        ></TextImageSection>
      </div>

      <Footer custumeClass="landing-page-footer !bg-inherit !border-0" />
    </>
  );
};
